import { render, staticRenderFns } from "./ClicSwaggerInterno.vue?vue&type=template&id=23ff8830&"
import script from "./ClicSwaggerInterno.vue?vue&type=script&lang=js&"
export * from "./ClicSwaggerInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports